import { trackEvent } from '../util/analytics'

up.compiler('[custom-analytics-event]', (element, data) => {

  const eventName = element.getAttribute('custom-analytics-event')

  trackEvent(eventName, data)
})
